export default {
  namespaced: true,
  state: {
    // 页面文档可视高度(随窗口改变大小)
    documentClientHeight: 0,
    // 导航条, 布局风格, defalut(默认) / inverse(反向)
    navbarLayoutType: 'inverse',
    // 侧边栏, 布局皮肤, light(浅色) / dark(黑色)
    sidebarLayoutSkin: 'dark',
    // 侧边栏, 折叠状态
    sidebarFold: false,
    // 侧边栏, 折叠状态
    topNavIndex: 0,
    leftMenu:true,//是否显示左侧菜单
    // 侧边栏, 菜单
    menuList: [],
    // 新版侧边栏, 菜单
    leftMenuList: {},
    topActiveMenuId:"",
    menuActiveName: '',
    // 主入口标签页
    mainTabs: [],
    mainTabsActiveName: '',
    activeMenuName:'首页',//当前选中的菜单名字
    topActiveIdx:0
  },
  mutations: {
    updateDocumentClientHeight (state, height) {
      state.documentClientHeight = height
    },
    updateNavbarLayoutType (state, type) {
      state.navbarLayoutType = type
    },
    updateSidebarLayoutSkin (state, skin) {
      state.sidebarLayoutSkin = skin
    },
    updateSidebarFold (state, fold) {
      state.sidebarFold = fold
    },
    updateMenuList (state, list) {
      state.menuList = list
    },
    updateLeftMenuList (state, list) {
      state.leftMenuList = list
    },
    updateTopActiveMenuId (state, list) {
      state.topActiveMenuId = list
    },
    updateMenuActiveName (state, name) {
      state.menuActiveName = name
    },
    updateMainTabs (state, tabs) {
      state.mainTabs = tabs
    },
    updateMainTabsActiveName (state, name) {
      state.mainTabsActiveName = name
    },
    updateTopNavIndex (state, name) {
      state.topNavIndex = name
    },
    updateLeftMenu (state, name) {
      state.leftMenu = name
    },
    updateActiveMenuName (state, name) {
      state.activeMenuName = name
    },
    updateTopActiveIdx (state, name) {
      state.topActiveIdx = name
    },

  }
}
